// flow weak

import React, {
    PureComponent,Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils';
  import TimeField from 'react-simple-timefield';
  import { Spinner } from 'react-activity';
  import { Table } from 'reactstrap';
  import styled from 'styled-components'
  import ReactTooltip from 'react-tooltip';
  import { Multiselect } from 'react-widgets';
  import Modal from 'react-modal';
  var Spinners = require('react-spinkit');

  const customStyles = {
    content : {
      top                   : '13%',
      left                  : '3%',
      right                 : '3%',
      bottom                : '3%',  
    },
      overlay: {
       background: "grey",
       overflow: 'hidden',
       position: 'fixed',
       zIndex   : '15'
     }
  };

    
  
  class EditCourtPricingRule extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);  
      this.state = {
        customer_search_list: [],
        details: {
            venue: props.match.params.id,
            starting_date:'',
            ending_date: '',
            slot_time: '',
            courts: [],
            amount: 0,
            cust_name: '',
            mobile_no: '',
            cust_mobile_no: '',
            customer_id: '',
            game_type: '',
            starting_time:'',
            ending_time:'',
            reason:3,
            discount_amount:0,
            advance_amount:0,
            reamining_amount:0,
            total_price:0,
            net_amount:0,
            selected_game:''
        },
        menuNav: props.match.params.booking_allowed == '6251' ? (localStorage.getItem('access') == 'Trespasser' ? false : true) : false,
        failed_list:[],
        game_list:[],
        message:'',
        venue_list: [],
        court_list: [],
        checkedBoxes:[],
        dayscheckedBoxes:[],
        blocked_court_list:[],
        available_court_list:[],
        court_pricing_list:[],
        isChecked: false,
        dialog_open_cust: false,
        deleteOption:false,
        search: false,
        add_Court_Price:false,
        time:'',
        new_court_price:0,
        previous_bulk_booking:'',
        blocked_for_bulk:'',
        available_for_bulk:'',
        submit_pressed:false,
        dialog_open_court_list:false,
        dialog_open_failed_list:false,
        show_booking_option:false,
        loading: true,
        selected_venue:props.match.params.id,
        court_booking_allowed: props.match.params.booking_allowed,
        new_court_size:0,
        field_type: 0,
        level:0,
        surface_type:0,
        selected_game:'',
        selected_start_day:0,
        selected_end_day:0,
        selected_start_time:'',
        selected_end_time:'',
        selected_rule_id:'',
        package_pricing:[],
        pricing_game_types:[],
        playing_options:[],
        content_loader:false,
        fetch_status_message:'',
        alert_modal:false,
        packages:[],
        edit_price:false,
        court_name_list:[],
        open: false,
        convTime:'',
        court_selected:[],
        selected_court:'',
        venue_id:'',
        game_id:'',
        start_time:'',
        end_time:'',
        no_pricing:'',
        game_level:[],
        create:false,
        game_types:[],
        game_levels:[],
        selected_game_id:[],
        selected_game_levels:[],
        duration:[],
        selected_game_type:'',
        selected_game_level:'',
        selected_playing_days:0,
        newpackageprice:'',
        show_percent:false,
        percent:false,
        game_type_t:'',
        days_option_t:'',
        quarterly:0,
        half_yearly:0,
        annual:0,
        pricing_details:[],
        showPackageModal: false,
        showDiscountModal: false,
        selectedPackage: [],
        newAmount: 0,
        isPkgPriceDeleted: false,
        isLoadingPkgPricing: false,
        isFlexiblePack: false,
        sessionsPerWeek: 0,
        searchValue:'',
        isPkgRecommended: false,
        isPkgActive: false,
        editingPackage: null,
        loadingDetailsForPackage: false,
        duration_list: [],
        selectedDurations: [],
        discountSettings: []
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleGameChange = this.handleGameChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.getCourtPricingforVenue = this.getCourtPricingforVenue.bind(this);
      this.handleSizeChange = this.handleSizeChange.bind(this);
      this.handleDaysCheckbox = this.handleDaysCheckbox.bind(this);
      this.handleEndDayChange = this.handleEndDayChange.bind(this);
      this.handleStartDayChange = this.handleStartDayChange.bind(this);
      this.onEndTimeChange = this.onEndTimeChange.bind(this);
      this.onStartTimeChange = this.onStartTimeChange.bind(this);
      this.handleNewVenueChange = this.handleNewVenueChange.bind(this);
      this.handleNewGameChange = this.handleNewGameChange.bind(this);
      this.toconfirmdeleting = this.toconfirmdeleting.bind(this);
      this.postDeleteCourtPrice = this.postDeleteCourtPrice.bind(this);
      this.onPriceChange=this.onPriceChange.bind(this);
      this.handleCourtChange=this.handleCourtChange.bind(this);
      this.tConvert12=this.tConvert12.bind(this);
      this.onCourtChange = this.onCourtChange.bind(this);
      this.handleGameTypeChange = this.handleGameTypeChange.bind(this);
      this.handleGameLevelChange = this.handleGameLevelChange.bind(this);
      this.handlePlayingDaysChange = this.handlePlayingDaysChange.bind(this);
      this.onDiscountChange = this.onDiscountChange.bind(this);
      this.getDiscountDetails = this.getDiscountDetails.bind(this);
      this.handleDurationChange = this.handleDurationChange.bind(this);
    }
  
    componentDidMount() {
        this.getVenueList();
        // this.getPackagePricing();  
        this.getPricingDetails();
    }

    getPricingDetails() {
      this.setState({isLoadingPkgPricing: true})
      const url = `${getLocationOrigin()}/package_details/get_pricings_for_venue/?venue_id=${this.state.details.venue}`
      const options = {...defaultOptions};

      return fetch(url,options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({pricing_details: data.result, duration_list: data.duration_list ,isLoadingPkgPricing:false},()=>{
              if(this.state.court_booking_allowed != '6251'){
                this.setState({loading: false})
              }
            })
          })
        .catch(error => error)
    }

    getVenueList(){
        const url = `${getLocationOrigin()}/court/get_rental_venue_for_buddy/`;
         const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {this.setState({ venue_list: data.results},()=>{this.setData(data)})
          })
           .catch(error => error);
    }

    getActiveVenueList(){
      console.log("getActiveVenueList")
      const url = `${getLocationOrigin()}/get_venue_list/get_active_venues_list/`;
      const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {this.setState({ active_venue_list: data.result})
        })
         .catch(error => error);
    }

    setData(data){
      console.log('setData')
      if(this.state.selected_venue){
        this.state.game_list = this.state.venue_list.filter(venue => venue.id == this.state.selected_venue)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
        this.state.start_time = this.state.venue_list.filter(venue => venue.id == this.state.selected_venue)[0].start_time
        this.state.end_time = this.state.venue_list.filter(venue => venue.id == this.state.selected_venue)[0].end_time
        if(this.state.end_time == "23:59:00"){
          let end_time = "00:00:00"
          this.setState({end_time:end_time})
        }
      this.setState({selected_venue:this.state.selected_venue,selected_game:this.state.game_list[0].game_id})
      this.getCourtPricingforVenue(this.state.selected_venue,this.state.venue_list.filter(venue => venue.id == this.state.selected_venue)[0].games[0].game_id)
      }
      else{
        let game_list = data.results[0].games
        let selected_venue = data.results[0].id
        let selected_game = game_list[0].game_id
        let start_time = data.results[0].start_time
        let end_time = data.results[0].end_time
        if(end_time == "23:59:00"){
          let end_time = "00:00:00"
        }
        this.setState({game_list:game_list,selected_game:selected_game,selected_venue:selected_venue,start_time:start_time,end_time:end_time})
        this.getCourtPricingforVenue(selected_venue,selected_game)
      }
    }
    handleOpen = () => {
      this.setState({open: true});
    };

    onEndTimeChange (e){
        this.setState({selected_end_time:e.target.value })
    }

    onStartTimeChange(e){
      this.setState({selected_start_time:e.target.value })
    }
    
    getCourtPricingforVenue(venue_id,game){
        if(this.state.court_booking_allowed === '6251'){
          
          var new_selected_one =  Object.assign({}, this.state.details);
          new_selected_one['venue'] = venue_id
          new_selected_one['game_type'] = game
          
          this.setState({details: new_selected_one,venue_id:venue_id,game_id:game});
          const url = `${getLocationOrigin()}/court/getCourtPricingForVenue/?venue_id=${venue_id}&game=${game}`;
          const options = {...defaultOptions};
      
          return fetch(url, options)
             .then(checkStatus)
             .then(parseJSON)
             .then(data => this.setState({ court_pricing_list: data.results,court_name_list:data.court_name,loading:false,selected_court:"All Courts",no_pricing:data.no_pricing_courts  }),
                      console.log("data")
              )
             .catch(error => error);
        }
        else{
          this.setState({loading:false})
        }
        
    }

    
    handleVenueChange(event){
      console.log(event.target.value)
     
      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      this.getCourtPricingforVenue(event.target.value,this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games[0].game_id)

      // this.getSlots(event.target.value)
    }

    handleGameChange(event){
      console.log(event.target.value)
      this.setState({selected_game:event.target.value});
      this.getCourtPricingforVenue(this.state.selected_venue,event.target.value);
    }

    onCourtChange(event){
      this.setState({selected_court:event.target.value});
      //this.getCourtPricingforVenue(this.state.selected_venue,event.target.value); 
    }

    handleNewVenueChange(event){
      console.log(event.target.value)
     
      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      

      // this.getSlots(event.target.value)
    }

    handleNewGameChange(event){
      console.log(event.target.value)
      this.setState({selected_game:event.target.value});
      
    }

    handleSizeChange(event){
        let name = event.target.name;
        if(name === 'size'){
          this.setState({new_court_size:event.target.value})
        }
        else if(name === 'surface_type'){
          this.setState({surface_type:event.target.value})
        }
        else if(name === 'level'){
          this.setState({level:event.target.value})
        }
        else{
          this.setState({field_type:event.target.value})
        }
    }

    handleStartDayChange(event){
      console.log(event.target.value)
      this.setState({selected_start_day:event.target.value})
    }

    handleEndDayChange(event){
      console.log(event.target.value)
      this.setState({selected_end_day:event.target.value})
    }

    handleStartDate(date){
      console.log(date)
      this.setState({selected_start_date:date});
    }

    handleEndDate(date){
      console.log(date)
      this.setState({selected_end_date:date})
    }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = event.target.value
        this.setState({details: new_value});
    }

    handleFormSubmit(event){
        event.preventDefault();
        this.check_availability(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
        // this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes, this.props)
    }

    

    handleOpen = () => {
        this.setState({dialog_open_cust:true,dialog_open_failed_list:true});
    };

    handleOpenPackageModal = (data) => {
      this.setState({showPackageModal: true,selectedPackage:data,newAmount:data.amount,isPkgPriceDeleted:data.is_deleted},()=>{
        this.setUpInitialDurationsEdit(data.packages)
      })
    }

    handleClosePackageModal  = () => {
      this.setState({
        showPackageModal: false,selectedPackage: []
      })
    }

    handleOpenDiscountModal = (data) => {
      const discountSettings = (data.packages || []).map(pkg => ({
        label: pkg.duration_label,
        days: pkg.days,
        duration: pkg.duration,
        discount_percent: pkg.discount_percent
      }));

      this.setState({
        showDiscountModal: true,
        selectedPackage: data,
        discountSettings
      },()=>this.setUpInitialDurationsEdit(data.packages));

    };

    handleDiscountChange = (index, value) => {
      this.setState(prev => {
        const updated = [...prev.discountSettings];
        updated[index] = {
          ...updated[index],
          discount_percent: value === '' ? '' : Math.max(0, Number(value))
        };
        return { discountSettings: updated };
      });
    };

    handleCloseDiscountModal  = () => {
      this.setState({showDiscountModal: false,selectedPackage: [], discountSettings: []})
    }

    setDiscount(){
      const url = `${getLocationOrigin()}/package_details/set_discount_for_packages/`;
      const options = {...defaultOptions};
      options['method'] = 'post'
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'package_pricing_id':this.state.selectedPackage.id,
                          'discountSettings':this.state.discountSettings,
                          'duration_settings':this.state.selectedDurations,
                        });

      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
          this.handleCloseDiscountModal()
          alert(response.message);
          this.getPricingDetails();
        })
      .catch((error) => {
          this.handleCloseDiscountModal()
          alert(error.message);
      });
    }

    handleCloseEditingPkg = () => {
      this.setState({
        editingPackage: null,
        isPkgActive: false,
        isPkgRecommended: false
      })
    }

    handleSubmitPkgPricing = () => {
      if(this.state.newAmount < 1) {
        alert('Amount should be a positive integer')
        return;
      }

      const url = `${getLocationOrigin()}/package_details/edit_package_pricing/`

      const options = {...defaultOptions}
      options['method'] = 'post'
      options['headers'] = {'content-type':'application/json'}
      options['body'] = JSON.stringify({
        package_pricing_id: this.state.selectedPackage.id,
        amount: this.state.newAmount,
        is_deleted: this.state.isPkgPriceDeleted,
        'duration_settings':this.state.selectedDurations
      })
      return fetch(url,options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response)=>{
        alert(response.message);
      })
      .catch((error)=> {
        alert("error while updating package pricing");
        console.log('handleSubmitPkgPricing_error',error)
      })
      .finally(()=>{
        this.getVenueList(); 
        this.getPricingDetails();
        this.handleClosePackageModal()
      })
    }

    handleSearchProgram = (e) => {
      this.setState({searchValue: e.target.value})
    }

    handleOpenPkgEditModal = (data) => {
      // this.setState({editingPackage: data,isPkgActive:data.is_active,isPkgRecommended:data.is_recommended})
    }

    handleSubmitPkgDetails = () => {
      const url = `${getLocationOrigin()}/package_details/edit_package/`

      const options = {...defaultOptions}
      options['method'] = 'post'
      options['headers'] = {'content-type':'application/json'}
      options['body'] = JSON.stringify({
        package_id: this.state.editingPackage.pk,
        isRecommended: this.state.isPkgRecommended,
        isActive: this.state.isPkgActive
      })
      return fetch(url,options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response)=>{
        alert(response.message);
      })
      .catch((error)=> {
        alert("error while updating package details");
      })
      .finally(()=>{ 
        this.getPricingDetails();
        this.handleCloseEditingPkg()
      })
    }
    

    handleDaysCheckbox = (e, s) => {
    const dayscheckedBoxes = [...this.state.dayscheckedBoxes];
    if(e.target.checked) {
        dayscheckedBoxes.push(s)
    } else {
        const index = dayscheckedBoxes.findIndex((ch) => ch.id === s.id);
        dayscheckedBoxes.splice(index, 1);
    }
    this.setState({dayscheckedBoxes:dayscheckedBoxes});
    console.log(dayscheckedBoxes)
    }
    
    handleClose = () => {
    this.setState({dialog_open_cust:false, dialog_open_court_list:false,dialog_open_failed_list:false,deleteOption:false,create:false,newpackageprice:'',selected_playing_days:0,isFlexiblePack:false,sessionsPerWeek:0});
    };

    updateCourtPrice(event){
      this.setState({new_court_price:event.target.value})
    }
    updateCourtSize(event){
      this.setState({new_court_size:event})
    }
    
    handleCheckbox = (e, s) => {
        const checkedBoxes = [...this.state.checkedBoxes];
        if(e.target.checked) {
            checkedBoxes.push(s)
        } else {
            const index = checkedBoxes.findIndex((ch) => ch.id === s.id);
            checkedBoxes.splice(index, 1);
        }
        this.setState({checkedBoxes:checkedBoxes});
    }

    toconfirmdeleting(id){
      this.setState({deleteOption:true,selected_rule_id:id})
    }

    postDeleteCourtPrice(){
      const url = `${getLocationOrigin()}/court/deleteCourtPricingRule/`;
      const options = {...defaultOptions};
      options['method'] = 'post'
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'court_price_id': this.state.selected_rule_id
                      });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {                  
          alert(response.message);
          window.location.reload();
          this.setState({new_court_price:0})
          // props.history.goBack();
          })
      .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({loading:false})
      });   
    }

    hitApplyRules(val) {
      const url = `${getLocationOrigin()}/court/create_pricing/?venue=${this.state.details.venue}&game=${this.state.selected_game}`;
      const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then((response) => {
            alert(response.message)
            this.setState({loading:false},()=>{
              if(val == true){
                window.location.reload()
              } 
            })
         }
          )
         .catch((error) => {
            alert(error.message)
            this.setState({loading:false})
         }
         )
    }

    applyRules(val) {
      this.setState({loading:true},()=>{this.hitApplyRules(val)})
    }

    addNewCourtPrice(){
      console.log("addNewCourtPrice")
      
      if(this.state.add_Court_Price){
        this.setState({add_Court_Price:false})
      }
      else{
          this.setState({add_Court_Price:true})
        }
        var element = document.getElementById('newCourtPrice');
      var topPos = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ 
        top:topPos-170,
        behavior: 'smooth'
      })
    }

    
    postNewCourtPriceRule(){

            var starting_time = "00:00:00"
            var end_time = "23:59:00"
            if(this.state.selected_start_time.length > 0){
              var starting_time = moment(this.state.selected_start_time, ["hh:mm"]).format("HH:mm:ss")
            }
            if(this.state.selected_end_time.length > 0){
              var end_time = moment(this.state.selected_end_time, ["hh:mm"]).format("HH:mm:ss")
            }
            if(this.state.selected_start_time === "00:00:00"){
                var starting_time = "00:00:00"
              }
            if(this.state.selected_end_time === "00:00:00"){
              var end_time = "23:59:00"
            }
            if(!this.state.selected_start_time){
              var starting_time = moment(this.state.start_time, ["hh:mm"]).format("HH:mm:ss")
              if(starting_time === "00:00:00"){
                var starting_time = "00:00:00"
              }
            }
            if(!this.state.selected_end_time){
              var end_time = moment(this.state.start_time, ["hh:mm"]).format("HH:mm:ss")
              if(end_time === "00:00:00"){
                var end_time = "23:59:00"
              }
            }
            console.log("start time",starting_time,"end time",end_time,"price",this.state.new_court_price)
            const url = `${getLocationOrigin()}/court/createCourtPricingRule/`;
            const options = {...defaultOptions};
            options['method'] = 'post'
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'venue_id':this.state.venue_id,
                                'game_id':this.state.game_id,
                                'courts':this.state.court_selected,
                                'new_court_price': this.state.new_court_price,
                                'starting_day':this.state.selected_start_day,
                                'end_day':this.state.selected_end_day,
                                'starting_time':starting_time,
                                'end_time':end_time,
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                alert(response.message);
                // window.location.reload();
                this.setState({new_court_price:0},()=>{
                  this.applyRules(true)
                })
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });

    }

    postCourtPrice(id) {
        console.log(id)
        if(this.state.new_court_price === '' || this.state.new_court_price === 0){
            alert("Enter court price")
        }
        else{
            const url = `${getLocationOrigin()}/court/updateCourtPricingRule/`;
            console.log(this.state.new_court_price)
            const options = {...defaultOptions};
            options['method'] = 'post'
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'court_price_id': id,
                                'new_court_price': this.state.new_court_price,
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                this.applyRules(false)
                this.getCourtPricingforVenue(this.state.venue_id,this.state.game_id)
                this.setState({new_court_price:0})
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });
        }
      }

    //   getPackagePricing(){
    //     const url = `${getLocationOrigin()}/package_details/get_pricings/?venue_id=${this.state.details.venue}`;
    //     const options = {...defaultOptions};
    
    //     return fetch(url, options)
    //        .then(checkStatus)
    //        .then(parseJSON)
    //        .then(data => {
    //           this.setState({ package_pricing: data.pricings,pricing_game_types:data.game_types,playing_options:data.playing_days_options,packages:data.packages,game_level:data.game_level,loading:false })
    //         })
    //        .catch(error => error);

    // }

    updatePackagePricing(){

      this.setState({content_loader:true})
      const url = `${getLocationOrigin()}/package_details/update_pricings/`;
      const options = {...defaultOptions};
      options['method'] = 'post'
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'package_pricings': this.state.package_pricing,'venue_id':this.state.details.venue});

      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
        this.setState({content_loader:false,alert_modal:true,fetch_status_message:response.message,edit_price:false})
        // this.getPackagePricing()
        this.getPricingDetails()
      })
      .catch((error) => {
        this.setState({content_loader:false,fetch_status_message:'Something went wrong'})
        console.log(error);
      });
    }


    onPriceChange(val,game_type_id,days_option){
      var pricings_copy = {...this.state.package_pricing}
      pricings_copy[game_type_id][days_option]["amount"] = val
      this.setState({package_pricing:pricings_copy})
    }  

    onDiscountChange(e){
      let val = e.target.value
      if(e.target.name == 'quarterly'){
        this.setState({quarterly:val})
      }
      if(e.target.name == 'half_yearly'){
        this.setState({half_yearly:val})
      }
      if(e.target.name == 'annual'){
        this.setState({annual:val})
      }
    }

    getDiscountDetails(pk,days_option,display_name){
      if(display_name.includes('Summer Camp')){
        this.setState({quarterly:0,half_yearly:0,annual:0,game_type_t:'',days_option_t:''})
      } 
      else{
        this.setState({show_percent:true,percent:false,game_type_t:pk,days_option_t:days_option,quarterly:0,half_yearly:0,annual:0})
      }     
    }

    handleAlert=()=>{
      this.setState({alert_modal:false})
    }
    handleEdit(){
      this.setState({edit_price:true})
    }
    handleRuleOpen=()=>{
      this.setState({open: true});
    }
    handleRuleClose = () => {
    this.setState({open: false});
    };

    handleCourtChange(id){

      let court_selected = this.state.court_selected
      let find = court_selected.indexOf(id)

      if(find > -1) {
        court_selected.splice(find, 1)
      } else {
        court_selected.push(id)
      }

      this.setState({ court_selected })
    }

    tConvert12(time){
      var inp_time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (inp_time.length > 1) { // If time format correct
        inp_time = inp_time.slice (1);  // Remove full string match value
        var x = +inp_time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        inp_time[0] = +inp_time[0] % 12 || 12; // Adjust hours
      }
      var convTime=inp_time.join ('')
      
      var cc=convTime.split(":")
      convTime=cc[0]+":"+cc[1]+x
      return convTime
    }

    tConvert24(str){
        // Get hours
    var h1 = Number(str[1] - '0');
    var h2 = Number(str[0] - '0');
    var hh = (h2 * 10 + h1 % 10);
    var conv=''
    var newConv=''
    // If time is in "AM"
    if (str[8] == 'A')
    {
        if (hh == 12)
        {
            //return("00");
            newConv="00"
            for (var i = 2; i <= 7; i++)
              conv=conv+str[i]
              //return(str[i]);
            return(newConv+conv)
        }
        else
        {
            for (var i = 0; i <= 7; i++)
                conv=conv+str[i]
                //return(str[i]);
            return conv
        }
    }
  
    // If time is in "PM"
    else
    {
        if (hh == 12)
        { 
            newConv="12"
            //return("12");
            for (var i = 2; i <= 7; i++)
              conv=conv+str[i]
              //return(str[i]);
            return(newConv+conv)
        }
        else
        {
            hh = hh + 12;
            newConv=hh
            for (var i = 2; i <= 7; i++)
                conv=conv+str[i]
                //return(str[i]);
            return(newConv+conv)
        }
    }
    }

    getdetailsforpackage(venue_id){
      this.setState({loadingDetailsForPackage: true})
      this.getActiveVenueList()
      this.setState({create:true})
      this.setUpInitialDurations()
      const url = `${getLocationOrigin()}/package_details/get_details_for_package_creation/?venue_id=${venue_id}`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
            this.setState({game_types:data.game_types,game_levels:data.game_levels,duration:data.duration},this.settingdata(data))
          })
         .catch(error => error)
         .finally(()=>{
          this.setState({loadingDetailsForPackage: false})
         })
    }

    settingdata(data){
      var game_type = data.game_types[0].pk
      const game_id = data.game_types[0].game.pk
      var game_level = data.game_levels.filter(each => each.game.pk == game_id)
      const game_level_id = game_level[0].pk
      this.setState({selected_game_levels:game_level,selected_game_type:game_type,selected_game_level:game_level_id})
    }

    handleGameTypeChange(event) {
      const value = event.target.value
      var game_type = this.state.game_types.find(each => each.pk == value)
      const game_id = game_type.game.pk
      var game_level = this.state.game_levels.filter(each => each.game.pk == game_id)
      const game_level_id = game_level[0].pk
      this.setState({selected_game_levels:game_level,selected_game_type:value,selected_game_level:game_level_id})
      if(game_type && game_type.game && game_type.game.name &&
       (game_type.game.name.toLowerCase() == 'swimming' || 
        game_type.game.name.toLowerCase() == 'badminton')) {
        this.setState({
          isFlexiblePack: true
        })
      }
    }

    updatepackageprice(event){
      this.setState({newpackageprice:event.target.value})
    }

    updatePackageAmount(event) {
      this.setState({newAmount:event.target.value})
    }

    handleGameLevelChange(event){
      this.setState({selected_game_level:event.target.value})
    }

    handlePlayingDaysChange(event){
      console.log('value',event.target.value)
      this.setState({selected_playing_days:event.target.value})
    }

    addnewpackage=()=>{
      if(!this.state.newpackageprice) {
        alert('Package price is required')
        return;
      }
      if(this.state.isFlexiblePack && this.state.sessionsPerWeek < 1) {
        alert('Sessions Per Week is required')
        return
      }
      this.setState({create:false})

      const url = `${getLocationOrigin()}/package_details/create_new_package/`;
      const options = {...defaultOptions};
      options['method'] = 'post'
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'venue_id':this.state.selected_venue,
                          'game_type_id':this.state.selected_game_type,
                          'game_level_id':this.state.selected_game_level,
                          'playing_days_options':this.state.selected_playing_days,
                          'package_price': this.state.newpackageprice,
                          'isFlexiblePack': this.state.isFlexiblePack,
                          'sessionsPerWeek': this.state.sessionsPerWeek,
                          'duration_settings':this.state.selectedDurations
                      });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
          console.log(response);
          alert(response.message);
          // this.setState({newpackageprice:'',selected_playing_days:0,isFlexiblePack:false,sessionsPerWeek:0},()=>this.getPackagePricing())
          this.setState({newpackageprice:'',selected_playing_days:0,isFlexiblePack:false,sessionsPerWeek:0},()=>this.getPricingDetails())

          })
      .catch((error) => {
          console.log(error);
          alert(error.message);
      })
      .finally(()=>{
        this.getVenueList();
        // this.getPackagePricing();  
        this.getPricingDetails();
      })
    }

    renderCols(len) {
      
      if(len === 4) return;
      let cols = 4 - len
      
      let colArr=  []

      for(let i=0;i<cols;i++) {
          colArr.push(<td></td>)
      } 
      return colArr   
    }

    renderPackagePricings() {
      return (
        <div>
          {this.state.isLoadingPkgPricing ? 
            <SpinnerDiv>
              <Spinners name="line-scale-pulse-out" color="rgb(101, 70, 138)" fadeIn='none' />
            </SpinnerDiv> 
             : 

             (
              <div>
                <div className='submit_button' style={styles.addBtn}>
                  <div style={styles.searchInfo}>
                    <div style={styles.searchContainer}>
                      <input type='text' placeholder='Search Program...' style={styles.searchBar} value={this.state.searchValue} onChange={this.handleSearchProgram}/>
                      <i className="fa fa-search" aria-hidden="true" style={{padding:'0 7px'}}></i>
                    </div>
                    <div style={{cursor:'pointer'}}>
                        <i 
                          style={{color:'#65468a'}}
                          data-tip='Note: You can click on the amounts to modify individual pack prices.<br/> To edit all prices within this rule at once, use the Edit button.' 
                          className="fa fa-info-circle fa-lg" 
                          aria-hidden="true"
                        >
                        </i>
                      <ReactTooltip html={true}/>
                    </div>
                  </div>
                  {(localStorage.getItem('access') == 'Trespasser' || localStorage.getItem('access') == 'Delivery Manager'  || localStorage.getItem('access') == 'Lead Buddy') &&
                    <ButtonSubmit style={{width:'auto'}}  onClick={()=>this.getdetailsforpackage(this.state.selected_venue)}>
                      <i className='fa fa-plus-circle' style={{marginRight:'3px'}} ></i> 
                      Create New Pricing
                    </ButtonSubmit>  
                  }
                </div>
               
                <Table responsive style={styles.packageTable}>
                  <thead>
                    <tr>
                      <th style={styles.pkgTabRow}>Program</th>
                      <th style={styles.actionTabRow}>Skill Level</th>
                      <th style={styles.actionTabRow}>Playing Days</th>
                      <th style={styles.actionTabRow}>Monthly</th>
                      <th style={styles.actionTabRow}>Quarterly</th>
                      <th style={styles.actionTabRow}>Semi Annual</th>
                      <th style={styles.actionTabRow}>Annual</th>
                      <th style={styles.actionTabRow}>Action</th>
                    </tr>
                  </thead>
                  {
                  this.state.pricing_details ? 
                    (this.state.pricing_details.filter(z=>(((z.game_type.toLowerCase()).includes((this.state.searchValue).toLowerCase()))
                    ||(z.game_level.toLowerCase()).includes((this.state.searchValue).toLowerCase()))).map((item,index)=>(
                      <tbody>
                        {item.game_type.includes('Summer Camp') ? (
                          <tr>
                            <td style={{verticalAlign:'middle'}}>{item.game_type}</td>
                            <td style={styles.tableData}>{item.game_level}</td>
                            <td style={styles.tableData}>{item.playing_days_option || 'N/A'}</td>
                            {
                              item.packages.filter(x => x.days).map(pack=>
                                <td style={styles.tableData} onClick={()=>this.handleOpenPkgEditModal(pack)}>    
                                  <span style={{paddingTop:'5px',textAlign:'right',textWrap:'nowrap',cursor:'pointer'}}>
                                    {pack.days && <span style={{paddingLeft:'2%'}}>{pack.days/7}&nbsp;weeks -&nbsp;</span>}  
                                    {pack.amount}  
                                    {pack.discount_amount ? <span style={styles.discountAmt}>({pack.discount_amount}%)</span> : null}
                                  </span>
                                </td>
                              )
                            }

                            {this.renderCols(item.packages.length)}
                                     
                            <td style={styles.editBtn} >
                              <i className="fa fa-pencil-square-o fa-lg" aria-hidden="true" style={{marginRight:'10px',cursor:'pointer'}} onClick={()=> this.handleOpenPackageModal(item)}></i>
                              <i className="fa fa-tag fa-lg" aria-hidden="true" onClick={()=> this.handleOpenDiscountModal(item)} style={{marginRight:'7px',cursor:'pointer'}} data-tip='Edit Custom Discount'></i>
                            </td> 
                          </tr>

                        ) : (
                              <tr key={index}>
                                <td style={{verticalAlign:'middle'}}>{item.game_type}</td>
                                <td style={styles.tableData}>{item.game_level}</td>
                                <td style={styles.tableData}>{item.playing_days_option || 'N/A'}</td>
                                <td style={styles.tableData} >
                                  {item.packages.filter( x=> x.days === 30).map(pack=> 
                                    <span style={styles.packAmt} onClick={()=>this.handleOpenPkgEditModal(pack)}>
                                      {pack.amount} 
                                      {pack.discount_amount ? <span style={styles.discountAmt}>({pack.discount_amount}%)</span> : null}
                                    </span>
                                  )}
                                </td>              
                                <td style={styles.tableData}>
                                  {item.packages.filter( x=> x.days === 90).map(pack=> 
                                    <span style={styles.packAmt} onClick={()=>this.handleOpenPkgEditModal(pack)}>
                                      {pack.amount} 
                                      {pack.discount_amount ? <span style={styles.discountAmt}>({pack.discount_amount}%)</span> : null}
                                    </span>
                                  )}
                                </td>
                                <td style={styles.tableData}>
                                  {item.packages.filter( x=> x.days === 180).map(pack=> 
                                    <span style={styles.packAmt} onClick={()=>this.handleOpenPkgEditModal(pack)}>
                                      {pack.amount} 
                                      {pack.discount_amount ? <span style={styles.discountAmt}>({pack.discount_amount}%)</span> : null}
                                    </span>
                                  )}
                                </td>
                                {item.packages.find(x=> x.days === 360 ) ? ( 
                                  <td style={styles.tableData}>
                                    {item.packages.filter( x=> x.days === 360).map(pack=> 
                                      <span style={styles.packAmt} onClick={()=>this.handleOpenPkgEditModal(pack)}>
                                        {pack.amount} 
                                        {pack.discount_amount ? <span style={styles.discountAmt}>({pack.discount_amount}%)</span> : null}
                                      </span>
                                    )}
                                  </td>
                                )
                                : item.packages.find(x => x.days === 300) ?
                                    <td style={styles.tableData} >
                                      {
                                        item.packages.filter(x => x.days === 300).map(pack=> 
                                          <span style={{paddingTop:'5px',textAlign:'right',textWrap:'nowrap',cursor:'pointer'}} onClick={()=>this.handleOpenPkgEditModal(pack)}>
                                            {pack.days && <span style={{paddingLeft:'2%'}}>10 months - &nbsp;</span>}
                                            {pack.amount} 
                                            {pack.discount_amount ? <span style={styles.discountAmt}>({pack.discount_amount}%)</span> : null}
                                          </span>
                                        )
                                      }
                                    </td>
                                  : <td></td>
                                }
                                <td style={styles.editBtn} >
                                  <i className="fa fa-pencil-square-o fa-lg" aria-hidden="true" style={{marginRight:'7px',cursor:'pointer'}} data-tip='Edit Pricing' onClick={()=> this.handleOpenPackageModal(item)}></i>
                                  <i className="fa fa-tag fa-lg" aria-hidden="true" onClick={()=> this.handleOpenDiscountModal(item)} style={{marginRight:'7px',cursor:'pointer'}} data-tip='Edit Custom Discount'></i>
                                  {/*<i className="fa fa-cog fa-lg" aria-hidden="true" onClick={()=> this.handleOpenDurationSetting(item)} style={{cursor:'pointer'}} data-tip='Set Durations'></i>*/}
                                </td> 
                              </tr>
                            )}
                      </tbody>
                    ))):
                      (
                        <p>No Data</p>
                      )
                  }
                </Table>

                {this.state.selectedPackage &&
                  <Modal                   
                    isOpen={this.state.showPackageModal}
                    onRequestClose={this.handleClosePackageModal}
                    style={customStyles}
                  >
                    <button
                      className="close close-sm"
                      data-dismiss="alert"
                      type="button"
                      style={styles.closeBtn}
                      onClick={this.handleClosePackageModal}
                      >
                      <i className="fa fa-times fa-2x"/>
                    </button>
                    
                    <div className='col-md-12 col-xs-12' style={styles.title}>
                      <h4 style={styles.head}>Edit Package Pricing</h4>
                    </div>
                    <div className='col-md-12 col-xs-12'>
                      <div className='col-md-12 col-xs-12' style={styles.gamePgm}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Program</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                          {this.state.selectedPackage.game_type}
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Skill Level</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                          {this.state.selectedPackage.game_level}
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Playing Days</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                          {this.state.selectedPackage.playing_days_option}
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Amount</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                          <input type="number" className="form-control" placeholder="-- enter the amount --" style={{width:'100%',padding:'6px'}} 
                            value={this.state.newAmount} onChange={(event)=>{this.updatePackageAmount(event)}}/> 
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Is Deleted</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444',display:'flex'}}>
                          <input checked={this.state.isPkgPriceDeleted} type='checkbox' onChange={()=>this.setState(prevState=>({
                            isPkgPriceDeleted: !prevState.isPkgPriceDeleted
                          }))}/>
                        </div>
                      </div> 
                      
                      {this.renderDurationSelector()}

                      <div className='col-md-12 col-xs-12' style={styles.subBtnCon}>
                        <button className='btn btn-primary' style={styles.submitPkgBtn} onClick={this.handleSubmitPkgPricing}>Submit</button>
                      </div>
                    </div>
                  </Modal>
                }

                {this.state.selectedPackage && this.state.showDiscountModal &&
                  <Dialog                   
                    modal={false}
                    open={this.state.showDiscountModal}
                    onRequestClose={this.handleCloseDiscountModal}
                  >
                    <button
                      className="close close-sm"
                      data-dismiss="alert"
                      type="button"
                      style={styles.closeBtn}
                      onClick={this.handleCloseDiscountModal}
                      >
                      <i className="fa fa-times fa-2x"/>
                    </button>
                    
                    <div className='col-md-12 col-xs-12' style={styles.title}>
                      <h4 style={styles.head}>Edit Discount Percentage</h4>
                    </div>
                    <div className='col-md-12 col-xs-12' style={{marginTop:'40px'}}>

                      {this.state.discountSettings.map((item, index) => (
                        <div key={item.days} className='col-md-12 col-xs-12' style={styles.discountField}>
                          
                          <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>
                            {item.label}
                          </div>

                          <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                            <input
                              className='form-control'
                              type='number'
                              step="1"
                              min="0"
                              value={item.discount_percent}
                              onChange={(e)=>this.handleDiscountChange(index, e.target.value)}
                              style={{width:'100%',padding:'6px'}}
                            />
                          </div>

                        </div>
                      ))}

                      <div className='col-md-12 col-xs-12' style={styles.subBtnCon}>
                        <button className='btn btn-primary' style={styles.submitPkgBtn} onClick={()=>this.setDiscount()}>
                          Submit
                        </button>
                      </div>

                    </div>

                  </Dialog>
                }

                {this.state.editingPackage &&
                  <Dialog                   
                    modal={false}
                    open={this.state.editingPackage}
                    onRequestClose={this.handleCloseEditingPkg}
                  >
                    <button
                      className="close close-sm"
                      data-dismiss="alert"
                      type="button"
                      style={styles.closeBtn}
                      onClick={this.handleCloseEditingPkg}
                    >
                      <i className="fa fa-times fa-2x" />
                    </button>

                    <div className='col-md-12 col-xs-12' style={styles.title}>
                      <h4 style={styles.head}>Edit Package Details</h4>
                    </div>
                    <div className='col-md-12 col-xs-12' style={{marginTop:'40px'}}>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Package Name</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                          <span>{this.state.editingPackage.name}</span>
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Game Level</div>
                        <div className='col-md-6 col-xs-12'style={{color:'#444444'}}> 
                          <span>{this.state.editingPackage.game_level_name}</span>
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Duration</div>
                        <div className='col-md-6 col-xs-12'style={{color:'#444444'}}> 
                          <span>{this.state.editingPackage.duration_label}</span>
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Amount</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444'}}> 
                          <span>{this.state.editingPackage.amount}</span>
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Is Active</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444',display:'flex'}}>
                          <input checked={this.state.isPkgActive} type='checkbox' onChange={()=>this.setState(prevState=>({
                            isPkgActive: !prevState.isPkgActive
                          }))}/>
                        </div>
                      </div> 
                      <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                        <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Is Recommended</div>
                        <div className='col-md-6 col-xs-12' style={{color:'#444444',display:'flex'}}>
                          <input checked={this.state.isPkgRecommended} type='checkbox' onChange={()=>this.setState(prevState=>({
                            isPkgRecommended: !prevState.isPkgRecommended
                          }))}/>
                        </div>
                      </div>
                      <div className='col-md-12 col-xs-12' style={styles.subBtnCon}>
                        <button className='btn btn-primary' style={{borderRadius:'5px',backgroundColor:'#65468a'}} onClick={this.handleSubmitPkgDetails}>Submit</button>
                      </div>                   
                    </div>
                </Dialog>
              }

              {this.state.create &&
                <Modal                   
                  isOpen={this.state.create}
                  onRequestClose={this.handleClose}
                  style={customStyles}
                >
                  <button
                    className="close close-sm"
                    data-dismiss="alert"
                    type="button"
                    style={styles.closeBtn}
                    onClick={this.handleClose}
                  >
                    <i className="fa fa-times fa-2x" />
                  </button>
                  <div className='col-md-12 col-xs-12' style={styles.title}>
                    <h4 style={styles.head}>Create New Pricing</h4>
                  </div>
                  {
                    this.state.loadingDetailsForPackage ?
                    <div style={{height:440}}>
                      <div style={{  position: 'absolute',top: '50%',left: '50%',width: '50%',height: '100%'}}> <Spinners size="50" name="ball-spin-fade-loader" color="#65468A" fadeIn='quarter'/></div>
                    </div>
                  :
                  <div className='col-md-12 col-xs-12'>
                    <div className='col-md-12 col-xs-12' style={styles.gamePgm}>
                      <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Venue</div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                        <select className="form-control" name="venue" style={styles.newPriceInput} value={this.state.selected_venue}
                          disabled={this.props.match.params.id ? 'disabled': ''}>
                          {this.state.active_venue_list.map((venue,index) =>
                          <option key={venue.id} value={venue.id}>{venue.value}</option>
                          )} 
                        </select>
                      </div>
                    </div>
                    <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                      <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Select Game Type</div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                        <select className="form-control" name="game_type" style={styles.newPriceInput} placeholder='--select game type--' 
                          value={this.state.selected_game_type}  onChange={this.handleGameTypeChange}>
                          {this.state.game_types.map((type,index) =>
                          <option key={type.pk} value={type.pk}>{type.game.name + ' ' + type.name}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                      <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Select Game Level</div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                        <select className="form-control" name="game_level" style={styles.newPriceInput} placeholder='--select game level--' 
                          value={this.state.selected_game_level} onChange={this.handleGameLevelChange}>                              
                          {this.state.selected_game_levels.map((level,index) =>
                          <option key={level.pk} value={level.pk}>{level.name}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                      <div className='col-md-6 col-xs-12'>
                        <div style={styles.pkgLabel}>
                          Is Flexible Pack ?
                        </div>
                        <p style={{fontSize:'12px',margin:0}}>Customers can choose specific days of the week to attend sessions.</p>
                      </div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444',display:'flex'}}>
                        <input checked={this.state.isFlexiblePack} type='checkbox' onChange={()=>this.setState(prevState=>({
                          isFlexiblePack: !prevState.isFlexiblePack
                        }))}/>
                      </div>
                    </div>
                    <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                      <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Select Playing Days</div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                        <select className="form-control" name="playing_days" style={styles.newPriceInput} placeholder='--select playing days--' 
                          value={this.state.selected_playing_days} onChange={this.handlePlayingDaysChange}>                              
                          {Object.keys(this.state.duration).map((days_option)=>
                          <option key={days_option} value={days_option}>{this.state.duration[days_option]}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                      <div className='col-md-6 col-xs-12' >
                        <div style={styles.pkgLabel}>Amount</div>
                        <p style={{fontSize:'12px',margin:0}}>Amount for one month.</p>
                      </div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                        <input type="number" className="form-control" placeholder="-- enter the amount --" style={styles.newPriceInput} 
                          value={this.state.newpackageprice} onChange={(event)=>{this.updatepackageprice(event)}}/> 
                      </div>
                    </div>
                    {this.state.isFlexiblePack && ( 
                    <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
                      <div className='col-md-6 col-xs-12' style={styles.pkgLabel}>Sessions Per Week</div>
                      <div className='col-md-6 col-xs-12' style={{color:'#444444'}}>
                        <input type="number" placeholder='Enter Sessions Per Week' min={0} style={styles.newPriceInput} value={this.state.sessionsPerWeek} onChange={(e)=>this.setState({sessionsPerWeek: e.target.value})}/>
                      </div>
                    </div>
                    )}

                    {this.renderDurationSelector()}

                    <div className='col-md-12 col-xs-12' style={styles.subBtnCon}>
                      <button className='btn btn-primary' style={{borderRadius:'5px',backgroundColor:'#65468a'}} onClick={this.addnewpackage}>Submit</button>
                    </div>  
                  </div>
                }
                </Modal>
              }
            </div>
          )}
        </div>
      )
    }

  setUpInitialDurations = () => {
    const defaultDays = [30, 90, 180, 360];

    const selectedDurations = this.state.duration_list
      .filter(d => defaultDays.includes(d.days))
      .map(d => ({
        label: d.label,
        days: d.days,
        active: true,
        showOnWebsite: true
      }));

    this.setState({ selectedDurations });

  };

  setUpInitialDurationsEdit = (packages) => {
    if (!packages || !packages.length) return;

    const selectedDurations = packages.map(pkg => ({
      label: pkg.duration_label,
      days: pkg.days,
      active: pkg.is_active,
      showOnWebsite: pkg.is_recommended,
    }));

    this.setState({ selectedDurations });
  };

  handleDurationChange = (selectedList) => {
    this.setState(prevState => {

      // preserve previous config if already selected
      const updated = selectedList.map(item => {

        const existing = prevState.selectedDurations.find(
          d => d.days === item.days
        );

        return existing
          ? existing   // keep active/showOnWebsite values
          : {
              label: item.label,
              days: item.days,
              active: true,
              showOnWebsite: true
            };
      });

      return { selectedDurations: updated };
    });
  };

  handleDurationCheckboxChange = (index, field) => (event) => {
    const checked = event.target.checked;

    this.setState(prevState => {

      const updatedDurations = [...prevState.selectedDurations];

      updatedDurations[index] = {
        ...updatedDurations[index],
        [field]: checked
      };

      return { selectedDurations: updatedDurations };
    });
  };

  renderDurationSelector = () => {

    const { duration_list, selectedDurations } = this.state;
    return (
      <div>
        <div className='col-md-12 col-xs-12' style={styles.gameLvl}>
          <div className='col-md-6 col-xs-12'>
            <div style={styles.pkgLabel}>Select Duration</div>
            <p style={{fontSize:'12px',margin:0}}>
              Choose the package durations you want to set up.
            </p>
          </div>

          <div className='col-md-6 col-xs-12'>
            <Multiselect
              data={duration_list}
              textField="label"
              valueField="days"
              value={selectedDurations.map(d => ({
                days: d.days,
                label: d.label
              }))}
              onChange={this.handleDurationChange}
              placeholder="Select duration"
            />
          </div>
        </div>

        {selectedDurations.length > 0 &&
          <div className="col-md-12 col-xs-12">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Duration Label</th>
                  <th>Days</th>
                  <th style={{ textAlign: 'center' }}>Active</th>
                  <th style={{ textAlign: 'center' }}>Show on Website</th>
                </tr>
              </thead>

              <tbody>
                {selectedDurations.map((item, index) => (
                  <tr key={item.days}>
                    <td>{item.label}</td>
                    <td>{item.days}</td>
                    <td style={{ textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={item.active}
                        onChange={this.handleDurationCheckboxChange(index, 'active')}
                      />
                    </td>

                    <td style={{ textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={item.showOnWebsite}
                        onChange={this.handleDurationCheckboxChange(index, 'showOnWebsite')}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>
    );
  };


    render() {
      console.log('render')
      console.log("---state---",this.state)
            
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,

      ];
      const alertAction=[
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleAlert}
        />
      ]
      const ruleAction=[
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleRuleClose}
        />,
        <FlatButton
          label="Save"
          primary={true}
          onClick={()=>{this.postNewCourtPriceRule()}}
        />,
      ]
      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Delete"
          primary={true}
          onClick={this.postDeleteCourtPrice}
        />,
      ];

      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleClose}
        />
      ];

      const createactions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
          style={{backgroundColor:'#dc4c64',color:'white',borderRadius:'5px',marginRight:'5px'}}
        />,
        <FlatButton
          label="Create Package"
          primary={true}
          onClick={this.addnewpackage}
          style={{backgroundColor:'#54b4d3',color:'white',borderRadius:'5px'}}

        />,
      ];
      
      var selected_court_field_type = new Set()
      var selected_court_surface_type = new Set()
      var selected_court_reference_courts = new Set([])
      var court_names = new Set()
      var courtRuleTableRow=["Days","Start Time","End Time","Court","Price","Actions"]
      var courtrule=["Days","Court"]
      var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]
      var times = ["00:00:00","00:30:00","01:00:00","01:30:00","02:00:00","02:30:00","03:00:00","03:30:00","04:00:00","04:30:00","05:00:00","05:30:00","06:00:00","06:30:00","07:00:00","07:30:00","08:00:00","08:30:00","09:00:00","09:30:00","10:00:00","10:30:00","11:00:00","11:30:00","12:00:00","12:30:00","13:00:00","13:30:00","14:00:00","14:30:00","15:00:00","15:30:00","16:00:00","16:30:00","17:00:00","17:30:00","18:00:00","18:30:00","19:00:00","19:30:00","20:00:00","20:30:00","21:00:00","21:30:00","22:00:00","22:30:00","23:00:00","23:30:00"]
      var SIZE_TYPE = [{id:0,name:'Default'},{id:1,name:'Five a side'},{id:2,name:'Seven a side'},{id:3,name:'Six a side'},{id:4,name:'Nine a side'}]
      var FIELD_TYPE = [{id:0,name:'Default'},{id:1,name:'Wooden'},{id:2,name:'Synthetic'},{id:3,name:'Hybrid'}]
      var SURFACE_TYPE = [{id:0,name:'Default'},{id:1,name:'Soft Surface'},{id:2,name:'Hard Surface'},{id:3,name:'Concrete'}]
      var LEVEL_TYPE = [{id:0,name:'Default'},{id:1,name:'1st Level'},{id:2,name:'2nd Level'},{id:3,name:'3rd Level'}]
      const pack_duration=[{id:"30 00:00:00",name:"Monthly"},{id:"90 00:00:00",name:"Quarterly"},{id:"180 00:00:00",name:"Semi Annual"},{id:"360 00:00:00",name:"Annual"}]
      const pack_duration_summer_camp=[{id:"14 00:00:00",name:"Two Weeks"},{id:"28 00:00:00",name:"Four Weeks"},{id:"42 00:00:00",name:"Six Weeks"}]
      return(
        this.state.loading ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
          :
            <div>
              <div style={{padding:'1%'}}>
                <button style={{borderColor:'#65468a',borderRadius:'50%',color:'#65468a'}} onClick={() => history.back()}><i className="fa fa-arrow-left" aria-hidden="true"></i></button>
              </div>  
              {
                this.state.court_booking_allowed === '6251' ? 
                  <div style={styles.topNav} >
                    <div className='courtPriceNav' onClick={()=> this.setState({menuNav:true})} style={{
                      backgroundColor:this.state.menuNav ? '#65468a' : 'white',
                      color:this.state.menuNav ? 'white' : 'black',
                    }}>    
                        Court Pricing 
                    </div>                    
                    <div className='courtPriceNav'  onClick={()=> this.setState({menuNav:false})} style={{
                      backgroundColor:this.state.menuNav ? 'white' : '#65468a',
                      color:this.state.menuNav ? 'black' : 'white',
                    }}>
                        Packages 
                    </div>   
                  </div>

                :
                  <div style={styles.topNavForPackages}>
                    <div className='courtPriceNav'>
                        Packages 
                    </div>
                  </div>
              }

              {/*
                localStorage.getItem('access') == 'Trespasser' ?
                  (this.state.court_booking_allowed === '6251' ? 
                                    <div style={styles.topNav} >
                                      <div className='courtPriceNav' onClick={()=> this.setState({menuNav:true})} style={{
                                        backgroundColor:this.state.menuNav ? '#65468a' : 'white',
                                        color:this.state.menuNav ? 'white' : 'black',
                                        }} >
                                      
                                        Court Pricing 
                                       
                                      </div>
                                          <div className='courtPriceNav'  onClick={()=> this.setState({menuNav:false})} style={{
                                            backgroundColor:this.state.menuNav ? 'white' : '#65468a',
                                            color:this.state.menuNav ? 'black' : 'white',
                                          }}>
                                              Packages 
                                          </div>
                                    </div>
                                  :
                                    <div style={styles.topNavForPackages}>
                                      <div className='courtPriceNav'>
                                          Packages 
                                      </div>
                                    </div>)
                  :
                    (
                        

                        <div style={styles.topNavForPackages}>
                          <div className='courtPriceNav'>
                              Court Pricing  
                          </div>
                        </div>
                    )
              */}


              {
                this.state.menuNav === true ?
                  
                  <div style={styles.container}>
                    <div className='col-lg-12' style={{display:'grid',gridTemplateColumns:'30% 70%',fontSize:'16px',marginBottom:'10px'}}>
                      <div className="col-lg-6" style={{textAlign:'left'}}>Select Venue </div>
                      <div className="col-lg-6">
                        <select name="venue" className="col-md-10" style={{ ...styles.item_body, backgroundColor: 'white', width: '100%' }} value={this.state.selected_venue}
                          onChange={this.handleVenueChange} disabled={this.props.match.params.id ? 'disabled': ''}>
                            {this.state.venue_list.map((venue,index) =>
                              <option key={venue.id} value={venue.id}>{venue.name}</option>
                            )} 
                        </select>
                      </div> 
                    </div>

                    <div className='col-lg-12' style={{display:'grid',gridTemplateColumns:'30% 70%',fontSize:'16px',marginBottom:'10px'}}>
                      <div className="col-lg-6" style={{textAlign:'left'}}>Select Game </div>
                      <div className="col-lg-6">
                        <select name="game" className="col-md-10" style={{ ...styles.item_body, backgroundColor: 'white', width: '100%' }} value={this.state.selected_game}
                          onChange={this.handleGameChange}>
                            {this.state.game_list.map((game,index) =>
                              <option key={game.game_id} value={game.game_id}>{game.game_name}</option>
                            )} 
                        </select>
                      </div> 
                    </div>
                    <div className='col-lg-12' style={{display:'grid',gridTemplateColumns:'30% 70%',fontSize:'16px',marginBottom:'10px'}}>
                      <div className="col-lg-6" style={{textAlign:'left'}}>Select Court </div>
                      <div className="col-lg-6">
                        <select name="court" className="col-md-10" style={{ ...styles.item_body, backgroundColor: 'white', width: '100%' }} onChange={this.onCourtChange} value={this.state.selected_court}>
                          <option value="All Courts">All Courts</option>
                          {this.state.court_name_list.map((court,index) =>
                            <option key={court.id} value={court.id}>{court.name}</option>
                          )} 
                        </select>        
                      </div> 
                    </div>

                    <form  className="validated-form form-horizontal" onSubmit={this.handleFormSubmit} style={{marginTop:'10px'}} >

                      <div style={{display:'flex',justifyContent:'center',alignItems:'center',backgroundColor:'#d6ccdf',padding:'6px',fontWeight:'900',borderRadius:'5px',marginBottom:'5px'}}>
                        <span>Pricing Rules - {this.state.selected_court === "All Courts" ? <span> All Courts </span> : this.state.court_name_list.map(court=>this.state.selected_court===court.id && court.name)}</span>
                      </div>
                      <div>
                        {this.state.court_pricing_list.map((court,index) => court.courts.map(x=> this.state.selected_court === x.id && <span style={{display:'none'}}>{selected_court_field_type.add(x.field_type)}</span> ) )}
                        {this.state.court_pricing_list.map((court,index) => court.courts.map(x=> this.state.selected_court === x.id && <span style={{display:'none'}}>{selected_court_surface_type.add(x.surface_type)}</span> ) )}
                        {this.state.court_pricing_list.map((court,index) => court.courts.map(x=> this.state.selected_court === x.id && <span style={{display:'none'}}>{x.reference_courts.map(item=>this.state.court_name_list.map(s=>s.id === item && selected_court_reference_courts.add(s.name)))}</span> ) )}
                        {
                          this.state.selected_court != "All Courts" &&
                          <div style={{display:'flex',justifyContent:'space-evenly',marginBottom:'5px'}}>
                            <div style={{border:'1px solid #d6ccdf',padding:'6px',borderRadius:'5px',fontWeight:'900'}}> Field Type -  {selected_court_field_type} </div>
                            <div style={{border:'1px solid #d6ccdf',padding:'6px',borderRadius:'5px',fontWeight:'900'}}> Surface Type - {selected_court_surface_type} </div>
                            {
                            selected_court_reference_courts.size > 1 && 
                              <div style={{border:'1px solid #d6ccdf',padding:'6px',borderRadius:'5px',fontWeight:'900'}}> Reference Courts - {new Array(...selected_court_reference_courts).join(' , ')}</div>
                            }
                          </div>
                        }   
                      </div>

                      <Table responsive style={styles.packageTable}>
                        <thead>
                          <tr style={styles.packageTableRow} >
                            {
                              courtRuleTableRow.map(row=>
                                  <th style={{textAlign:'center'}}> {row} </th>
                                )
                            }
                          </tr>
                        </thead>
                        <tbody>
                          
                          {
                            this.state.court_pricing_list.map((court,index) =>
                              this.state.selected_court === "All Courts" ?
                              <tr>
                                <td style={{display:'flex',justifyContent:'center',alignItems:'center'}} >
                                  { days.map((day,index)=>{return (day.id == court.starting_day && <div>{day.name}</div>) })} - { days.map((day,index)=>{return (day.id == court.ending_day && <div>{day.name}</div>) })}
                                </td>
                                <td> {this.tConvert12(court.start_time)} </td>
                                <td> {this.tConvert12(court.end_time) === '11:59PM' ? <span> 12:00AM </span> : this.tConvert12(court.end_time)} </td>
                                <td> {court.courts.map(x=> <div> {x.name} </div>)} </td>
                                <td> 
                                  <UpdateInput style={{width:'65px'}} type="number" className="required" name="advance_amount" value={this.state.value} placeholder={court.price}
                                            onChange={(event)=>{this.updateCourtPrice(event)}}/> 
                                </td>
                                <td style={{display:'flex',justifyContent:'space-evenly'}}> 

                                  <input type="button"  value="Update" onClick={()=>{this.postCourtPrice(court.id)}} />
                                 
                                  <input type="button" style={{'backgroundColor':"red"}} value="DELETE" onClick={()=>{this.toconfirmdeleting(court.id)}} /> 
                                  {this.state.deleteOption &&
                                          <Dialog
                                            actions={dialog_actions}
                                            modal={false}
                                            open={this.state.deleteOption}
                                            onClick={this.handleClose}
                                            autoDetectWindowHeight={true}
                                            autoScrollBodyContent={true}
                                            scroll={scroll}
                                            dividers={scroll === 'paper'}
                                          >

                                          <div className="col-md-12">
                                            <h4 style={{textAlign:'center','color':"red"}}>Do you want to delete this rule</h4>
                                          </div>
                                          </Dialog>
                                  }
                                </td>

                              </tr>

                              :

                              court.courts.map(x=>
                                this.state.selected_court === x.id && 
                                  <tr>
                                    <td style={{display:'flex',justifyContent:'center',alignItems:'center'}} >
                                      { days.map((day,index)=>{return (day.id == court.starting_day && <div>{day.name}</div>) })} - { days.map((day,index)=>{return (day.id == court.ending_day && <div>{day.name}</div>) })}
                                    </td>
                                    <td> {this.tConvert12(court.start_time)} </td>
                                    <td> {this.tConvert12(court.end_time)} </td>
                                    <td> {court.courts.map(xs=> <div> {xs.name} </div>)} </td>
                                    <td> 
                                      <UpdateInput style={{width:'65px'}} type="number" className="required" name="advance_amount" value={this.state.value} placeholder={court.price}
                                                onChange={(event)=>{this.updateCourtPrice(event)}}/> 
                                    </td>
                                    <td style={{display:'flex',justifyContent:'space-evenly'}}> 

                                      <input type="button"  value="Update" onClick={()=>{this.postCourtPrice(court.id)}} />
                                     
                                      <input type="button" style={{'backgroundColor':"red"}} value="DELETE" onClick={()=>{this.toconfirmdeleting(court.id)}} /> 
                                      {this.state.deleteOption &&
                                              <Dialog
                                                actions={dialog_actions}
                                                modal={false}
                                                open={this.state.deleteOption}
                                                onClick={this.handleClose}
                                                autoDetectWindowHeight={true}
                                                autoScrollBodyContent={true}
                                                scroll={scroll}
                                                dividers={scroll === 'paper'}
                                              >

                                              <div className="col-md-12">
                                                <h4 style={{textAlign:'center','color':"red"}}>Do you want to delete this rule</h4>
                                              </div>
                                              </Dialog>
                                      }
                                    </td>

                                  </tr>

                              )
                              
                            )
                          }
                          
                        </tbody>
                      </Table>
                    </form>

                    { this.state.no_pricing.length > 0 &&
                      <div className="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        {this.state.no_pricing.map(court=>
                          <b>{court},</b>
                          )
                        }
                        <span> does not have any pricing rules</span>
                      </div>
                    }
                 
                    <div className="col-md-12" style={{'marginTop':"10px",'fontSize':"16px",'float':"center"}}> 
                      <ButtonSubmit style={{width:'115px',marginRight:'10px',fontSize:'small'}} onClick={()=>{this.addNewCourtPrice()}}> <i className='fa fa-plus-circle' style={{marginRight:'4px'}} ></i> Add New Rule </ButtonSubmit>
                        <div id="newCourtPrice">
                          {this.state.add_Court_Price && 
                            <div style={{marginTop:'20px'}}>
                              <div className='col-lg-12' style={{fontSize:'16px',marginBottom:'10px'}}>
                                <div className="alert alert-info" role="alert">Working Time : From {moment(this.state.start_time, ["HH:mm"]).format("h:mm A")} To {moment(this.state.end_time, ["HH:mm"]).format("h:mm A")} 
                                {this.state.end_time == "00:00:00" && <b>(24 Hour Working)</b>}
                                </div>
                              </div>
                          
                              <div className='col-lg-12' style={{fontSize:'16px',marginBottom:'10px'}}>
                                <div className="col-md-12 col-lg-6" style={{display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'900',padding:'3px'}}>Select Date </div>
                                <div className="col-md-12 col-lg-4" style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'3px'}} >
                                  <div> From </div>

                                  <select name="size" className="col-md-4" style={styles.item_body}  value={this.state.selected_start_day}
                                    onChange={this.handleStartDayChange}>
                                   {days.map((day,index) =>
                                    <option key={day.id} value={day.id} >{day.name}</option>
                                   )} 
                                  </select>
                                  <div> To </div>
                                  <select name="size" className="col-md-4" style={styles.item_body}  value={this.state.selected_end_day}
                                    onChange={this.handleEndDayChange}>
                                   {days.map((day,index) =>
                                    <option key={day.id} value={day.id}>{day.name}</option>
                                   )} 
                                  </select>
                                </div> 
                              </div>

                              <div className='col-lg-12' style={{fontSize:'16px',marginBottom:'10px'}}>
                                <div className="col-md-12 col-lg-6" style={{display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'900',padding:'3px'}}>Select Time </div>
                                <div className="col-md-12 col-lg-4" style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'3px'}} >
                                  <div> From </div>

                                  <select name="size" value={this.state.selected_start_time} style={styles.item_body} onChange={this.onStartTimeChange}>
                                    {times.map((time,index) =>
                                      this.state.start_time !=this.state.end_time ?
                                      this.state.start_time <= time && this.state.end_time >= time &&
                                      <option value={time} >{moment(time, ["HH:mm"]).format("hh:mm A")}</option>
                                      :
                                      <option value={time} >{moment(time, ["HH:mm"]).format("hh:mm A")}</option>
                                    )} 
                                  </select>
                                  <div> To </div>
                                  <select name="size" value={this.state.selected_end_time} style={styles.item_body} onChange={this.onEndTimeChange}>
                                    {times.map((time,index) =>
                                      this.state.start_time !=this.state.end_time ?
                                      this.state.start_time <= time && this.state.end_time >= time &&
                                      <option value={time} >{moment(time, ["HH:mm"]).format("hh:mm A")}</option>
                                      :
                                      <option value={time} >{moment(time, ["HH:mm"]).format("hh:mm A")}</option>
                                    )} 
                                  </select>
                                </div> 
                              </div>  

                              <div className='col-lg-12' style={{fontSize:'16px',marginBottom:'10px'}}>
                                <div className="col-md-12 col-lg-6" style={{display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'900',padding:'3px'}}>Select court </div>
                                <div className="col-md-12 col-lg-4" style={{display:'grid',gridTemplateColumns:'auto auto auto auto',padding:'3px'}} >
                                  {
                                    this.state.court_name_list.map((item,index)=>
                                      <div>
                                        <input type="checkbox" id={item.id} onChange={()=>this.handleCourtChange(item.id)} selected={ this.state.court_selected.includes(item.id) } name="court" value={item.id} /> {item.name}
                                      </div>
                                    )
                                  }
                                </div> 
                              </div>

                              <div className='col-lg-12' style={{fontSize:'16px',marginBottom:'10px'}}>
                                <div className="col-md-12 col-lg-6" style={{display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'900',padding:'3px'}}>Enter Price </div>
                                <div className="col-md-12 col-lg-4" style={{display:'flex',justifyContent:'center',alignItems:'center',padding:'3px'}} >
                                  <input required type="number" className="required" name="advance_amount" value={this.state.value} onChange={(event)=>{this.updateCourtPrice(event)}} style={{width:'100%'}}/> 
                                </div> 
                              </div>

                              <div className="col-md-12" style={{marginTop: '15px'}}>
                                  <ButtonSubmit onClick={()=>{this.postNewCourtPriceRule()}}> <i className='fa fa-save' style={{marginRight:'3px'}} ></i> Save </ButtonSubmit>
                              </div>  

                            </div>
                          }

                        </div>
                      <div id="newCourtPric" style={{height:'100px',display:this.state.add_Court_Price && 'none'}}></div>
                    </div>
                </div>
            
            
              : 
              this.state.edit_price ? 

                <div className='col-md-12' style={{position:'relative'}} >
                  <div style={{position:this.state.content_loader && 'absolute',left:this.state.content_loader && '0',right:this.state.content_loader && '0',opacity:this.state.content_loader && '0.1',pointerEvents:this.state.content_loader && 'none'}} >
                    <Table responsive style={styles.packageTable}>
                      <thead>
                        <tr style={styles.packageTableRow} >
                          <th></th>
                          {
                            Object.keys(this.state.playing_options).map((days_option,index)=>
                                <th style={styles.packageTableCom}> {this.state.playing_options[days_option]} </th>
                              )
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.pricing_game_types.map((game_type,index)=>
                            <tr>
                              <th style={styles.packageTableCom}> {game_type.display_name}</th>
                              {
                                Object.keys(this.state.playing_options).map((days_option)=>                                
                                  <td style={styles.packageTableCom}>

                                    {/*
                                      game_type.display_name === 'Football Academy' || game_type.display_name === 'Badminton Academy' ?
                                      (
                                        this.state.playing_options[days_option] === 'Weekday' || this.state.playing_options[days_option] === 'Weekend'? '-' :
                                      <div>
                                        <PackageInput 
                                        type='number' 
                                        value={this.state.package_pricing[game_type.pk][days_option]["amount"]} 
                                        onChange={(e)=>this.onPriceChange(e.target.value,game_type.pk,days_option)}
                                        onClick={()=>this.getDiscountDetails(game_type.pk,days_option,game_type.display_name)} 
                                        /> 
                                        {this.state.show_percent && game_type.pk == this.state.game_type_t && days_option == this.state.days_option_t && 
                                          <button className='btn btn-xs btn-primary' type='button' style={{backgroundColor:'#65468a',fontWeight:900}} onClick={()=>this.setState({percent:true})}>Edit Discount %</button>}
                                      </div>
                                      )

                                      :*/}
                                      <div>
                                        <PackageInput 
                                          type='number' 
                                          value={this.state.package_pricing[game_type.pk][days_option]["amount"]} 
                                          onChange={(e)=>this.onPriceChange(e.target.value,game_type.pk,days_option)} 
                                          onClick={()=>this.getDiscountDetails(game_type.pk,days_option,game_type.display_name)} 
                                        /> 
                                        {this.state.show_percent && game_type.pk == this.state.game_type_t && days_option == this.state.days_option_t && 
                                          <button className='btn btn-xs btn-primary' type='button' style={{backgroundColor:'#65468a',fontWeight:900}} onClick={()=>this.setState({percent:true})}>Edit Discount %</button>}
                                      </div>
                                        
                                        
                                        {this.state.percent && game_type.pk == this.state.game_type_t && days_option == this.state.days_option_t &&
                                          <div style={{marginTop:'1%'}}>
                                            <div>
                                              <label>Discount Percentage</label>
                                              <span onClick={()=>this.setState({percent:false,quarterly:0,half_yearly:0,annual:0,game_type_t:'',days_option_t:''})}>
                                              <i className='fa fa-times' style={{color:'red',paddingLeft:'2%',cursor:'pointer',fontSize:'large'}}/>
                                              </span>
                                            </div>
                                            <div>
                                              <label>Quarterly:</label>
                                              <PackageInput name='quarterly' 
                                                onChange={(e)=>this.onDiscountChange(e)} 
                                                value={this.state.quarterly} />
                                            </div>
                                            <div>
                                              <label>Semi-Annual:</label>
                                              <PackageInput name='half_yearly' 
                                                onChange={(e)=>this.onDiscountChange(e)} 
                                                value={this.state.half_yearly} />
                                            </div>
                                            <div>
                                              <label>Annual:</label>
                                              <PackageInput name='annual' 
                                                onChange={(e)=>this.onDiscountChange(e)} 
                                                value={this.state.annual} />
                                            </div>
                                            <button className='btn btn-primary' type='button' onClick={()=>this.setDiscount()}>Set Discount</button>
                                          </div>
                                        }
                                  </td> 
                              )
                             }
                          </tr>
                          )
                        }
                      </tbody>
                  </Table>
                  <div className='submit_button' style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <ButtonSubmit onClick={()=>this.setState({edit_price:false,show_percent:false,percent:false,quarterly:0,half_yearly:0,annual:0})} style={{marginRight:'8px'}}>
                      <i className='fa fa-times-circle' style={{marginRight:'3px'}} ></i> Cancel
                    </ButtonSubmit> 
                    <ButtonSubmit onClick={()=>this.updatePackagePricing()}>
                      <i className='fa fa-save' style={{marginRight:'3px'}} ></i> Save
                    </ButtonSubmit>
                  </div>
                </div>
                {
                    this.state.fetch_status_message.length > 0 && 
                      <Dialog actions={alertAction} open={this.state.alert_modal} modal={false} onRequestClose={this.handleAlert}>
                        {this.state.fetch_status_message}
                      </Dialog>
                  }
                  {
                    this.state.content_loader && 
                    <SpinnerDiv>
                        <Spinners name="line-scale-pulse-out" color="rgb(101, 70, 138)" fadeIn='none' />
                  </SpinnerDiv>
                  }
               </div>


            :

              <div className='col-md-12' style={{position:'relative'}} >
                
                {this.renderPackagePricings()}
              {/*<div style={{position:this.state.content_loader && 'absolute',left:this.state.content_loader && '0',right:this.state.content_loader && '0',opacity:this.state.content_loader && '0.1',pointerEvents:this.state.content_loader && 'none'}} >*/}
                {/*<Table responsive style={styles.packageTable}>

                  <thead>
                    <tr style={styles.packageTableRow} >
                      <th></th><th></th>
                      {
                        Object.keys(this.state.playing_options).map((days_option,index)=>
                            <th style={styles.packageTableCom}> {this.state.playing_options[days_option]} </th>
                          )
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.pricing_game_types.map((game_types,index)=>
                        <tr>
                          <th style={styles.packageTableCom} style={{whiteSpace:'pre-wrap',display:'flex',justifyContent:'center',alignItems:'center',height:'16vh',color:'rgb(52 16 95)'}} >{game_types.display_name} </th>
                          <th>
                            {
                              game_types.display_name.includes('Summer Camp') ? 
                                pack_duration_summer_camp.map(pack=> <tr> <th style={{paddingTop:'5px',color:'rgb(101,70,138)'}} > {pack.name} </th> </tr>)
                              :
                                pack_duration.map(pack=> <tr> <th style={{paddingTop:'5px',color:'rgb(101,70,138)'}} > {pack.name} </th> </tr>)
                            }
                            
                          </th>
                          
                             {
                              Object.keys(this.state.playing_options).map((days_option)=>
                                
                                  <th style={styles.packageTableCom}>
                                        {
                                          game_types.display_name.includes('Summer Camp') ? 
                                            pack_duration_summer_camp.map(pack=>
                                              <tr>
                                                {this.state.packages.filter( x=> x.game_type === game_types.pk && x.playing_days_option == days_option && x.duration === pack.id ).map(price=>                                                
                                                    <td style={{paddingTop:'5px',textAlign:'right'}}> {price.amount} </td>
                                                  )}
                                              </tr>
                                            )
                                          :
                                            pack_duration.map(pack=>
                                              <tr>
                                                {this.state.packages.filter( x=> x.game_type === game_types.pk && x.playing_days_option == days_option && x.duration === pack.id ).map(price=>  
                                                  price.name.includes('Advanced') || price.name.includes('Intermediate') || price.game_level == 15 || price.game_level == 3?
                                                    null
                                                  :
                                                    <td style={{paddingTop:'5px',textAlign:'right'}}> {price.amount}  
                                                    {price.discount_amount ?
                                                      <span style={{paddingLeft:'2%',color:'green',fontSize:'12px'}}>({price.discount_amount}%)</span> 
                                                      :null
                                                    } 
                                                    </td>
                                                  )}
                                              </tr>
                                            )
                                        }                                                                  
                                  </th> 
                              )
                             }
                      </tr>
                      )
                    }
                    {
                      this.state.game_level.map((level,index)=>
                      <tr>
                        <th style={styles.packageTableCom} style={{whiteSpace:'pre-wrap',display:'flex',justifyContent:'center',alignItems:'center',height:'16vh',color:'rgb(52 16 95)'}} >{level.name} </th>
                        <th>
                          {
                            pack_duration.map(pack=> <tr> 
                             
                              <th style={{paddingTop:'5px',color:'rgb(101,70,138)'}} > {pack.name} </th> 
                            
                              </tr>)
                          }
                        </th>
                        {
                          Object.keys(this.state.playing_options).map((days_option)=>
                            <th style={styles.packageTableCom}>
                            {
                              pack_duration.map(pack=>
                              <tr>
                                {this.state.packages.filter( x=> x.playing_days_option == days_option && x.duration === pack.id && x.game_level === level.id && x.game_type === level.game_type_id).map(price=> 
                                  <td style={{paddingTop:'5px',textAlign:'right'}}>{price.amount} 
                                    {price.discount_amount ?
                                      <span style={{paddingLeft:'2%',color:'green',fontSize:'12px'}}>({price.discount_amount}%)</span>
                                      :null
                                    } 
                                  </td>
                                )}
                              </tr>
                              )
                            }
                            </th> 
                          )
                        }
                      </tr>
                      
                      )
                    }
                  </tbody>
                </Table>*/}
                  
                {/*  { (localStorage.getItem('access') == 'Trespasser' || localStorage.getItem('access') == 'Delivery Manager') &&
                    <div className='submit_button' style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:'2%'}}>
                     <ButtonSubmit onClick={()=>this.handleEdit()} style={{marginRight:'8px'}}>
                        <i className='fa fa-edit' style={{marginRight:'3px'}} ></i> Edit Price
                      </ButtonSubmit>
                      <ButtonSubmit style={{width:'145px'}}  onClick={()=>this.getdetailsforpackage(this.state.selected_venue)}>
                        <i className='fa fa-plus-circle' style={{marginRight:'3px'}} ></i> Add Elite Packages
                      </ButtonSubmit>  
                    </div>
                }*/}

               

                {/*</div>*/}
                {
                  this.state.fetch_status_message.length > 0 && 
                    <Dialog actions={alertAction} open={this.state.alert_modal} modal={false} onRequestClose={this.handleAlert}>
                      {this.state.fetch_status_message}
                    </Dialog>
                }
                {
                  this.state.content_loader && 
                  <SpinnerDiv>
                      <Spinners name="line-scale-pulse-out" color="rgb(101, 70, 138)" fadeIn='none' />
                </SpinnerDiv>
                }
                
              </div>

            }
          </div>

    );
    }
  }
  export default EditCourtPricingRule;
  


const PackageInput = styled.input`
  background-color:inherit;
  width:60px;
  padding:3px;
  text-align:center;
  border:none;
  outline:none;
  &:focus,&:hover{
    border-bottom:1px solid rgb(101, 70, 138);
  }
`
const UpdateInput = styled.input`
  text-align:center;
  &::placeholder{
    color:black;
    font-size:13px;
    text-align:center;
  }
`

const ButtonSubmit=styled.button`
  color: white;
  padding: 5px;
  outline: none;
  border: none;
  width: 100px;
  height:35px;
  border-radius: 5px;
  font-weight: 900;
  background-color: rgb(101, 70, 138);
  cursor: pointer;
`
const PeriodMenu=styled.div`
  
`

const SpinnerDiv =styled.div`
    height:63vh;
    display:flex;
    justify-content:center;
    align-items:center;
    z-index:9;
`



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editCourtPricing/index.js